import { ValidationErrorData } from '../../typings/common';

export const SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR = 'SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR';
export type SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR = typeof SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR;

export interface ShowErrorsCampaignServiceEditor {
    type: SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR;
    editorId: string;
    errors: ValidationErrorData[];
}

export function showErrorsCampaignServiceEditorAction(
    editorId: string,
    errors: ValidationErrorData[]
): ShowErrorsCampaignServiceEditor {
    return {
        type: SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR,
        editorId,
        errors
    };
}
